import { render, staticRenderFns } from "./WhatsappView.vue?vue&type=template&id=9343b49a&scoped=true"
import script from "./WhatsappView.vue?vue&type=script&lang=js"
export * from "./WhatsappView.vue?vue&type=script&lang=js"
import style0 from "./WhatsappView.vue?vue&type=style&index=0&id=9343b49a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9343b49a",
  null
  
)

export default component.exports